module.exports = __webpack_public_path__ + "assets/media/navigations-desktop-vkontakte.5a5472a6.svg";